import type * as React from "react";

import { cn } from "../lib/cn";

export interface EmptyNoteProps extends React.HTMLAttributes<HTMLParagraphElement> {
  /**
   * The sentence. Brian's voice per DESIGN.md: first person, plain, dry, no
   * exclamation, no emoji. "Nothing in this room." not "No items found!" One
   * sentence, and when in doubt say less.
   */
  children: React.ReactNode;
  ref?: React.Ref<HTMLParagraphElement>;
}

/**
 * What a list says when there is nothing in it: one line of Brian's handwriting
 * in the middle of the empty page. Annotation ink, because an empty list is not
 * a failure or a warning - it is a note about the paper, and a note about the
 * paper is quieter than anything written on it. Nothing else belongs here: no
 * illustration, no call to action, no bright surface asking to be noticed.
 *
 * It centres itself in the panel body it fills (`h-full`), so hand it the whole
 * body. For a failure, that is `PanelError`; for a load, `Skeleton`.
 */
export function EmptyNote({ children, className, ...rest }: EmptyNoteProps) {
  return (
    <p
      className={cn(
        "flex h-full items-center justify-center p-10 text-sm text-annotation",
        className,
      )}
      {...rest}
    >
      {children}
    </p>
  );
}
